define("ember-svg-jar/inlined/insights", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M9.333 18.503v7h-7v-4.666l2.334-2.334h4.666zM17.5 4.608v20.895h-7V6.942l2.333-2.334H17.5zm8.167 6.032v14.863h-7v-12.53L21 10.64h4.667z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});